import Link from '@amzn/meridian/link';
import React, { FC } from 'react';
import { Trans } from 'react-i18next';
import createUser3 from '../../../assets/CreateUser3.png';
import createUserNavigation from '../../../assets/createUserNavigation.png';
import createUserScreen from '../../../assets/createUserScreen.png';
import { SiteHelpCallback } from '../../../constants';
import { useTranslation } from '../../blocks';
import { HelpBody, HelpBullet, HelpImage, HelpIndent, HelpStep, HelpTitle } from './HelpElements';

const CreateUserHelp: FC<SiteHelpCallback> = () => {
    const { t } = useTranslation('createUserHelp');

    return (
        <>
            <HelpTitle>{t('createUserHelp_Title')}</HelpTitle>
            <HelpBody>{t('createUserHelp_purpose')}</HelpBody>
            <HelpStep step={1}>
                <Trans
                    i18nKey={'createUserHelp_step1'}
                    ns={'createUserHelp'}
                    components={{ url: <Link href={'https://reseller.amazon.com'}>{''}</Link> }}
                />
            </HelpStep>
            <HelpStep step={2}>{t('createUserHelp_step2')}</HelpStep>
            <HelpStep step={3}>{t('createUserHelp_step3')}</HelpStep>
            <HelpImage src={createUserNavigation} />
            <HelpStep step={4}>{t('createUserHelp_step4')}</HelpStep>
            <HelpIndent>
                <HelpBullet>{t('createUserHelp_role_claimsCreator')}</HelpBullet>
                <HelpBullet>{t('createUserHelp_role_claimsViewer')}</HelpBullet>
                <HelpBullet>{t('createUserHelp_role_admin')}</HelpBullet>
                <HelpBullet>{t('createUserHelp_role_creator')}</HelpBullet>
                <HelpBullet>{t('createUserHelp_role_viewer')}</HelpBullet>
            </HelpIndent>
            <HelpImage size={'large'} src={createUserScreen} />
            <HelpStep step={5}>{t('createUserHelp_step5')}</HelpStep>
            <HelpStep step={6}>{t('createUserHelp_step6')}</HelpStep>
            <HelpImage src={createUser3} />
            <HelpStep step={7}>{t('createUserHelp_step7')}</HelpStep>
        </>
    );
};

export { CreateUserHelp };
